// removed by extract-text-webpack-plugin
module.exports = {"pageItem":"_3GYlqYIzgin-TjFhRWXFnj","active":"_3X5ewrj-Fxx869CyWsu9Pp","nextPage":"_1rQQ6pCm1K4Q7vd-jqVYk3","prevPage":"_29Ck3HSW4egtlY0gXIDtxQ","gap":"yIvn7BYr1WtVJwV3nHT2a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/Pagination.scss
// module id = 625
// module chunks = 1